import React from 'react';
import './Navbar.css'

const Navbar = () => {
  return (
    <nav id="navbar">
      <ul>
        <li><a href="#game">Game Page</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;